import { Conversation } from 'lib-shared-legacy-types';

export function canTakeOverConversation(
  conversation: Conversation,
  isAssignedToMe: boolean,
): boolean {
  return (
    !isAssignedToMe && !conversation.is_closed && !!conversation.assignment
  );
}
